import { render, staticRenderFns } from "./SupportTicket.vue?vue&type=template&id=72537d93&"
import script from "./SupportTicket.vue?vue&type=script&lang=js&"
export * from "./SupportTicket.vue?vue&type=script&lang=js&"
import style0 from "./SupportTicket.vue?vue&type=style&index=0&id=72537d93&prod&lang=scss&"
import style1 from "./SupportTicket.vue?vue&type=style&index=1&id=72537d93&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports